module.exports = __webpack_public_path__ + "img/banner.bb9e5f37.jpg";